import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import * as actions from '../actions';
import {
  UpdateUser,
  UpdateUserSuccess,
  UpdateUserError,
} from '../action-creators';
import { debounceTime, mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as users from '@webapp/sdk/users';
import { updatedUserSideEffect } from '@webapp/utils/user/update-user-rudderstack';

export const updateUserEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, UpdateUser>(actions.UPDATE_USER),
    debounceTime(1000),
    mergeMap(async ({ onboarding, userData, redirectedFrom }) => {
      try {
        const updatedProfile = await users.updateProfile(userData);
        await updatedUserSideEffect({
          userId: updatedProfile.id,
          full_name: updatedProfile.fullName,
          country: updatedProfile.country?.name,
          state: updatedProfile.address?.state,
          city: updatedProfile.address?.city,
          email_addresses: [
            { email: updatedProfile.email, is_primary: true },
            ...(updatedProfile.additionalEmails?.map((account) => ({
              email: account.value,
              is_primary: false,
            })) || []),
          ],
          phone_numbers: [
            { phone_number: updatedProfile.telephone },
            ...(updatedProfile.additionalTelephones?.map((account) => ({
              phone_number: account.value,
              country_code: account.code,
              country_name: account.country?.name,
            })) || []),
          ],
          address_line1: updatedProfile.address?.address,
          address_line2: updatedProfile.address?.address2,
        });

        return new UpdateUserSuccess(
          updatedProfile,
          onboarding,
          redirectedFrom
        );
      } catch (err) {
        return new UpdateUserError((err as Error).message);
      }
    })
  );
